<template>
  <div>
    <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1600" @input="handleClosePopup">
      <div style="background-color: #fff">
        <div class="header-modal">
          <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
            <span style="color: #0081c7">{{ fields.title }}</span>
            <v-btn icon @click="handleClosePopup">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </div>

        <v-card-text style="max-height: 70vh; overflow-y: auto">
          <div class="mb-4">
            <label class="label-input">Section</label>
            <v-row>
              <v-col cols="12" md="8">
                <v-text-field v-model="fields.title" label="Name" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
              </v-col>
            </v-row>
          </div>

          <div class="mb-4">
            <label class="label-input">Title card</label>
            <div class="group-item">
              <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
            </div>
          </div>

          <v-row>
            <v-col cols="12" md="6">
              <div class="mb-4">
                <label class="label-input">Colors</label>
                <div class="group-item">
                  <v-row>
                    <v-col cols="12" md="4">
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.backgroundColor"
                          @change="e => (fields.backgroundColor = e.target.value)"
                        />
                        <v-text-field v-model="fields.backgroundColor" label="Background" hide-details dense />
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.textColor"
                          @change="e => (fields.textColor = e.target.value)"
                        />
                        <v-text-field v-model="fields.textColor" label="Text Color" hide-details dense />
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.colorStar"
                          @change="e => (fields.colorStar = e.target.value)"
                        />
                        <v-text-field v-model="fields.colorStar" label="Star Color" hide-details dense />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="mb-4">
                <label class="label-input">Container page</label>
                <div class="group-item">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-checkbox
                        v-model="fields['container-page'].showStyleContainer"
                        label="Show style"
                        hide-details
                        dense
                      />
                    </v-col>
                    <v-col cols="12" md="8">
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields['container-page'].backgroundContainer"
                          @change="e => (fields['container-page'].backgroundContainer = e.target.value)"
                        />
                        <v-text-field
                          v-model="fields['container-page'].backgroundContainer"
                          label="Container background"
                          hide-details
                          dense
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>

          <div class="mb-4">
            <v-row>
              <v-col cols="12" md="6">
                <div class="label-input">Admin reply</div>
                <div class="group-item">
                  <v-row>
                    <v-col cols="12" md="12">
                      <UploadImage
                        @callback="obj => (fields.admin.avatar = obj.imageSrc)"
                        :image="{ imageSrc: fields.admin.avatar }"
                        :height="`150`"
                        :typeUpload="'image'"
                        @callbackDelete="() => (fields.admin.avatar = '')"
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field v-model="fields.admin.name" label="Admin Name" />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input">Product reivew</div>
                <div class="group-item">
                  <v-row>
                    <v-col cols="12" md="12">
                      <UploadImage
                        @callback="obj => (fields.productReview.imge = obj.imageSrc)"
                        :image="{ imageSrc: fields.productReview.imge }"
                        :height="`150`"
                        :typeUpload="'image'"
                        @callbackDelete="() => (fields.productReview.imge = '')"
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field v-model="fields.productReview.title" label="Product Review Title" />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-text-field v-model="fields.productReview.name" label="Product Name" />
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>

          <div class="mb-6">
            <div class="label-input mt-6">Page limit</div>
            <div class="group-item">
              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field v-model.number="fields.pageLimit" type="number" min="1" label="Page Limit" />
                </v-col>
              </v-row>
            </div>
          </div>

          <div>
            <div class="mb-4 d-flex justify-space-between align-center">
              <label class="label-input mb-0">Reviews</label>
              <div class="d-flex gap-2" style="gap: 8px; align-items: center">
                <!-- <v-btn small text color="error" :disabled="!selectedRows.length" @click="removeSelected">
                  Delete selected
                </v-btn> -->
                <div v-if="selectedRows.length > 0" class="selected-info">
                  <span class="selected-count">{{ selectedRows.length }} selected</span>
                  <v-btn small text color="error" @click="removeSelected">
                    <v-icon size="16" class="mr-1">mdi-delete</v-icon>
                    Delete Selected
                  </v-btn>
                </div>
                <v-text-field
                  outlined
                  small
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  dense
                  hide-details
                  label="Search by name/title"
                  style="max-width: 280px"
                />
                <div class="import-section">
                  <v-btn color="primary" @click="showImportModal = true">
                    <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                    <span>Add reviews</span>
                  </v-btn>
                </div>
                <div class="export-section">
                  <v-btn
                    :disabled="!fields.listItemReview || fields.listItemReview.length === 0"
                    color="success"
                    @click="handleExportReviews"
                  >
                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                    <span>Export reviews</span>
                  </v-btn>
                </div>
                <!-- <v-btn small color="primary" @click="handleAddRow">Add</v-btn> -->
              </div>
            </div>
            <v-data-table
              v-model="selectedRows"
              show-select
              item-key="id"
              :headers="headers"
              :items="filteredRows"
              :items-per-page="10"
              dense
            >
              <template v-slot:item.avatar="{ item }">
                <img
                  :src="item.avatar"
                  alt=""
                  style="width: 28px; height: 28px; border-radius: 50%; object-fit: cover"
                />
              </template>
              <template v-slot:item.name="{ item }">
                <v-text-field small dense outlined hide-details v-model="item.name" label="" />
              </template>
              <template v-slot:item.title="{ item }">
                <v-text-field small outlined dense hide-details v-model="item.title" rows="3" />
              </template>
              <template v-slot:item.content="{ item }">
                <v-textarea small dense hide-details v-model="item.content" label="" rows="3" />
              </template>
              <template v-slot:item.stars="{ item }">
                <v-rating
                  color="warning"
                  background-color="#c1c1c1"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="5"
                  size="20"
                  v-model="item.stars"
                />
              </template>
              <template v-slot:item.results="{ item }">
                <v-text-field
                  small
                  outlined
                  dense
                  hide-details
                  v-model.number="item.results"
                  type="number"
                  min="1"
                  max="5"
                />
              </template>
              <template v-slot:item.easeOfUse="{ item }">
                <v-text-field
                  small
                  outlined
                  dense
                  hide-details
                  v-model.number="item.easeOfUse"
                  type="number"
                  min="1"
                  max="5"
                />
              </template>
              <template v-slot:item.taste="{ item }">
                <v-text-field
                  small
                  outlined
                  dense
                  hide-details
                  v-model.number="item.taste"
                  type="number"
                  min="1"
                  max="5"
                />
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon small @click="openEdit(item)"><v-icon size="18">mdi-pencil</v-icon></v-btn>
                <v-btn icon small @click="removeRow(item.id)"
                  ><v-icon size="18" color="error">mdi-delete</v-icon></v-btn
                >
              </template>
            </v-data-table>
            <div class="mt-2">
              <v-btn small text color="error" :disabled="!selectedRows.length" @click="removeSelected">
                Delete selected
              </v-btn>
            </div>
          </div>
        </v-card-text>

        <div class="footer-modal">
          <v-card-actions style="padding: 10px 0">
            <v-spacer />
            <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
            <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogEdit" max-width="600">
      <v-card>
        <div class="header-modal">
          <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
            <span style="color: #0081c7">Edit review</span>
            <v-btn icon @click="handleCancelEdit">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="editingRow.name" label="Name" />
            </v-col>
            <v-col cols="12">
              <div class="label-input-sub2">Avatar</div>
              <div class="group-item2">
                <UploadImage
                  @callback="obj => (editingRow.avatar = obj.imageSrc)"
                  :image="{ imageSrc: editingRow.avatar }"
                  :height="`150`"
                  :typeUpload="'image'"
                  @callbackDelete="() => (editingRow.avatar = '')"
                />
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <!-- <v-text-field v-model.number="editingRow.stars" type="number" min="1" max="5" label="Stars (1-5)" /> -->
              <div>
                <div>Stars</div>
                <v-rating
                  color="warning"
                  background-color="#c1c1c1"
                  empty-icon="mdi-star-outline"
                  full-icon="mdi-star"
                  half-icon="mdi-star-half-full"
                  hover
                  length="5"
                  size="20"
                  v-model="editingRow.stars"
                />
              </div>
            </v-col>

            <v-col cols="12" md="4"
              ><v-text-field v-model.number="editingRow.results" type="number" min="1" max="5" label="Results"
            /></v-col>
            <v-col cols="12" md="4"
              ><v-text-field v-model.number="editingRow.easeOfUse" type="number" min="1" max="5" label="Ease of Use"
            /></v-col>
            <v-col cols="12" md="4"
              ><v-text-field v-model.number="editingRow.taste" type="number" min="1" max="5" label="Taste"
            /></v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="editingRow.like" type="number" min="0" max="100" label="Like" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="editingRow.dislike" type="number" min="0" max="100" label="Dislike" />
            </v-col>
            <v-col cols="12" md="12"><v-text-field v-model="editingRow.title" label="Title"/></v-col>
            <v-col cols="12"><v-textarea outlined dense v-model="editingRow.content" label="Content" rows="4"/></v-col>
            <v-col cols="12">
              <!-- <v-textarea v-model="editingRow.replyContent" label="Admin reply" rows="3" /> -->
              <div>
                <div class="d-flex justify-space-between align-center mb-2">
                  <label class="label-input" style="margin-bottom: 0">Admin replies</label>
                  <v-btn small text color="primary" @click="addReply">
                    <v-icon size="16">mdi-plus</v-icon>
                    <span>Add Reply</span>
                  </v-btn>
                </div>
                <v-expansion-panels accordion>
                  <v-expansion-panel v-for="(reply, replyIndex) in editingRow.replies" :key="replyIndex">
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between align-center">
                        <span>Reply {{ replyIndex + 1 }}</span>
                        <v-btn
                          icon
                          :disabled="editingRow.replies.length <= 1"
                          @click.stop="handleRemoveReply(replyIndex)"
                        >
                          <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                        </v-btn>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-textarea outlined dense v-model="reply.content" rows="3" class="mb-3" />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="d-flex justify-space-between align-center mb-2">
                <div class="label-input mb-2">Images review</div>
                <v-btn small text color="primary" class="mt-2 px-0" @click="addReviewImageSlot">
                  <v-icon left small>mdi-plus</v-icon>
                  Add image
                </v-btn>
              </div>
              <div class="d-flex flex-wrap gap-3 align-start">
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(imgUrl, idx) in editingRow.reviewImages"
                    :key="'edit-review-img-' + idx"
                    class="review-image-slot"
                  >
                    <UploadImage
                      @callback="obj => onReviewImageUploaded(idx, obj.imageSrc)"
                      :image="{ imageSrc: imgUrl }"
                      :height="`120`"
                      :typeUpload="'image'"
                      @callbackDelete="() => removeReviewImageAt(idx)"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="footer-modal">
          <v-card-actions style="padding: 10px 0">
            <v-spacer />
            <v-btn text @click="handleCancelEdit">Cancel</v-btn>
            <v-btn color="primary" @click="saveEdit">Apply</v-btn>
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>

    <!-- Review Image Upload Dialog -->
    <ReviewImageDialog
      :reviewImageDialog="reviewImageDialog"
      @update:reviewImageDialog="v => (reviewImageDialog = v)"
      :editingImageIndex="editingImageIndex"
      :currentReviewImage="currentReviewImage"
      @cancel-review-image="handleCancelReviewImageDialog"
      @review-image-uploaded="handleReviewImageUploaded"
      @remove-review-image-dialog="handleRemoveReviewImageDialog"
      @save-review-image="handleSaveReviewImage"
    />

    <!-- CSV Import Modal -->
    <ImportReviewsDialog
      :typeReview="'vital'"
      :showImportModal="showImportModal"
      :csvTemplateUrl="'/csv/product-reviews-template-vital-1.csv'"
      @update:showImportModal="v => (showImportModal = v)"
      :importTab="importTab"
      :manualReview="manualReview"
      :editor="editor"
      :editorConfig="editorConfig"
      :randomReviewsCount="randomReviewsCount"
      :maxRandomReviewsCount="maxRandomReviewsCount"
      :selectedGender="selectedGender"
      :genderOptions="genderOptions"
      :formValid="formValid"
      :isDragging="isDragging"
      :csvFile="csvFile"
      :csvLoading="csvLoading"
      :csvError="csvError"
      :importedReviews="importedReviews"
      :duplicateCount="duplicateCount"
      @close-import-modal="handleCloseImportModal"
      @set-dragging="v => (isDragging = v)"
      @drop-file="handleDrop"
      @file-select="handleFileSelect"
      @remove-csv-file="handleRemoveCsvFile"
      @save-add-reviews="handleSaveAddReviews"
      @update:manualReview="v => (manualReview = v)"
      @update:importTab="v => (importTab = v)"
      @update:randomReviewsCount="v => (randomReviewsCount = v)"
      @update:selectedGender="v => (selectedGender = v)"
      @manual-add-image="handleManualAddImage"
      @manual-preview-image="handlePreviewImage"
      @manual-edit-image="handleManualEditImage"
    />
  </div>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ImportReviewsDialog from './product-reviews/import-reviews-dialog.vue';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
// import productReviewsJson from '@/assets/json/product-reviews.json'
import addReviewProduct from '@/mixins/addReviewProduct';
import ReviewImageDialog from './product-reviews/review-image-dialog.vue';

export default {
  name: 'ReviewVitalSectionEditor',
  components: { UploadImage, ImportReviewsDialog, ReviewImageDialog },
  mixins: [addReviewProduct],
  props: {
    sectionEditor: { type: Object, required: true },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      search: '',
      dialogEdit: false,
      selectedRows: [],
      editingRow: {
        id: null,
        name: '',
        avatar: '',
        title: '',
        stars: 5,
        results: 5,
        easeOfUse: 5,
        taste: 5,
        content: '',
        reviewImages: [],
        replyContent: '',
      },
      fields: {
        title: 'Review Vital Section',
        enableAnchor: false,
        titleCard: '',
        colorStar: '#214a88',
        backgroundColor: '#ffffff',
        textColor: '#000000',
        'container-page': {
          backgroundContainer: '#FFFFFF',
          showStyleContainer: false,
        },
        admin: { avatar: '', name: '' },
        productReview: { title: '', name: '', imge: '' },
        pageLimit: 1,
        listItemReview: [],
      },
      headers: [
        { text: 'Avatar', value: 'avatar', sortable: false, width: 80 },
        { text: 'User', value: 'name', width: 150 },
        { text: 'Title', value: 'title', width: 200 },
        { text: 'Content', value: 'content', width: 300 },
        // { text: 'Images', value: 'imageCount', sortable: false, width: 80 },
        { text: 'Stars', value: 'stars', width: 90 },
        { text: 'Results', value: 'results', width: 100 },
        { text: 'Ease', value: 'easeOfUse', width: 100 },
        { text: 'Taste', value: 'taste', width: 100 },
        // { text: 'Like', value: 'like', width: 100 },
        // { text: 'Dislike', value: 'dislike', width: 100 },
        { text: 'Actions', value: 'actions', sortable: false, width: 120 },
      ],
    };
  },
  computed: {
    filteredRows() {
      const q = (this.search || '').toLowerCase();
      if (!q) return this.fields.listItemReview || [];
      return (this.fields.listItemReview || []).filter(
        item => (item.name || '').toLowerCase().includes(q) || (item.title || '').toLowerCase().includes(q),
      );
    },
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
    if (!Array.isArray(this.fields.listItemReview)) this.fields.listItemReview = [];
  },
  methods: {
    addReply() {
      this.editingRow.replies.push({ content: '' });
    },
    handleRemoveReply(index) {
      this.editingRow.replies.splice(index, 1);
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionReviewVital(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddRow() {
      const ts = Date.now();
      this.fields.listItemReview.push({
        id: ts,
        name: '',
        avatar: '',
        stars: 5,
        title: '',
        content: '',
        results: 5,
        easeOfUse: 5,
        taste: 5,
        media: { img: [] },
        replies: [],
        like: 0,
        dislike: 0,
      });
    },
    removeRow(id) {
      this.fields.listItemReview = (this.fields.listItemReview || []).filter(item => item.id !== id);
    },
    removeSelected() {
      const ids = new Set((this.selectedRows || []).map(item => item.id));
      this.fields.listItemReview = (this.fields.listItemReview || []).filter(item => !ids.has(item.id));
      this.selectedRows = [];
    },
    openEdit(item) {
      const urls = (item.media?.img || []).map(i => (i && i.url ? String(i.url).trim() : '')).filter(Boolean);
      this.editingRow = {
        ...item,
        reviewImages: urls.length ? [...urls] : [],
      };
      this.dialogEdit = true;
    },
    addReviewImageSlot() {
      if (!this.editingRow.reviewImages) this.$set(this.editingRow, 'reviewImages', []);
      this.editingRow.reviewImages.push('');
    },
    removeReviewImageAt(idx) {
      if (!this.editingRow.reviewImages) return;
      this.editingRow.reviewImages.splice(idx, 1);
    },
    onReviewImageUploaded(idx, imageSrc) {
      const url = (imageSrc || '').trim();
      if (!this.editingRow.reviewImages) this.$set(this.editingRow, 'reviewImages', []);
      this.$set(this.editingRow.reviewImages, idx, url);
    },
    saveEdit() {
      if (!this.editingRow) return;
      const { reviewImages, ...rowCore } = this.editingRow;
      const imgs = (reviewImages || [])
        .map(u => (typeof u === 'string' ? u.trim() : ''))
        .filter(Boolean)
        .map(url => ({ url }));
      this.fields.listItemReview = (this.fields.listItemReview || []).map(item => {
        if (item.id !== rowCore.id) return item;
        return {
          ...item,
          ...rowCore,
          media: { img: imgs },
          replies: this.editingRow.replies,
        };
      });
      this.handleCancelEdit();
    },
    handleCancelEdit() {
      this.dialogEdit = false;
      this.editingRow = {
        id: null,
        name: '',
        avatar: '',
        title: '',
        stars: 5,
        results: 5,
        easeOfUse: 5,
        taste: 5,
        content: '',
        reviewImages: [],
        replyContent: '',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.label-input-sub {
  font-size: 16px !important;
  font-weight: 500;
  color: #000;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.selected-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border-left: 4px solid #1976d2;
  width: fit-content;
  margin-left: auto;
}
</style>
